import { render, staticRenderFns } from "./CellRendererActionsHistories.vue?vue&type=template&id=a1968e54"
import script from "./CellRendererActionsHistories.vue?vue&type=script&lang=js"
export * from "./CellRendererActionsHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports